import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import { MessageModal } from '../components/modals/MessageModal';
export function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsMessageModalOpen(true);
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    });
  };
  return <div className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933] flex flex-col" data-id="element-3251">
      <header className="bg-white border-b border-gray-300 py-4 px-6 md:px-12" data-id="element-3252">
        <Link to="/" className="flex items-center gap-2" data-id="element-3253">
          <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-3254"></div>
          <span className="font-bold text-xl tracking-tight" data-id="element-3255">
            Citiplots.com
          </span>
        </Link>
      </header>

      <main className="flex-1 max-w-6xl mx-auto px-6 py-12" data-id="element-3256">
        <h1 className="text-4xl font-bold mb-4" data-id="element-3257">Contact Us</h1>
        <p className="text-lg text-gray-500 mb-12 font-mono" data-id="element-3258">
          We're here to help with your plot transaction needs
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-3259">
          {/* Contact Info */}
          <div className="space-y-6" data-id="element-3260">
            <div className="bg-white border border-gray-300 p-6" data-id="element-3261">
              <h2 className="font-bold text-lg mb-4" data-id="element-3262">Get in Touch</h2>

              <div className="space-y-4" data-id="element-3263">
                <div className="flex items-start gap-3" data-id="element-3264">
                  <Mail className="w-5 h-5 text-gray-500 mt-0.5" data-id="element-3265" />
                  <div data-id="element-3266">
                    <p className="text-sm font-bold" data-id="element-3267">Email</p>
                    <a href="mailto:support@citiplots.com" className="text-sm text-gray-600 hover:text-[#1f2933]" data-id="element-3268">
                      support@citiplots.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3" data-id="element-3269">
                  <Phone className="w-5 h-5 text-gray-500 mt-0.5" data-id="element-3270" />
                  <div data-id="element-3271">
                    <p className="text-sm font-bold" data-id="element-3272">Phone</p>
                    <a href="tel:+911234567890" className="text-sm text-gray-600 hover:text-[#1f2933]" data-id="element-3273">
                      +91 123 456 7890
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3" data-id="element-3274">
                  <MapPin className="w-5 h-5 text-gray-500 mt-0.5" data-id="element-3275" />
                  <div data-id="element-3276">
                    <p className="text-sm font-bold" data-id="element-3277">Address</p>
                    <p className="text-sm text-gray-600" data-id="element-3278">
                      123 Business Park
                      <br data-id="element-3279" />
                      Hinjewadi Phase 1<br data-id="element-3280" />
                      Pune, Maharashtra 411057
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3" data-id="element-3281">
                  <Clock className="w-5 h-5 text-gray-500 mt-0.5" data-id="element-3282" />
                  <div data-id="element-3283">
                    <p className="text-sm font-bold" data-id="element-3284">Business Hours</p>
                    <p className="text-sm text-gray-600" data-id="element-3285">
                      Mon - Fri: 9:00 AM - 6:00 PM
                      <br data-id="element-3286" />
                      Sat: 10:00 AM - 4:00 PM
                      <br data-id="element-3287" />
                      Sun: Closed
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white border border-gray-300 p-6" data-id="element-3288">
              <h3 className="font-bold mb-3" data-id="element-3289">Quick Links</h3>
              <ul className="space-y-2 text-sm" data-id="element-3290">
                <li data-id="element-3291">
                  <Link to="/faq" className="text-gray-600 hover:text-[#1f2933]" data-id="element-3292">
                    Frequently Asked Questions
                  </Link>
                </li>
                <li data-id="element-3293">
                  <Link to="/support" className="text-gray-600 hover:text-[#1f2933]" data-id="element-3294">
                    Support Center
                  </Link>
                </li>
                <li data-id="element-3295">
                  <Link to="/legal-guides" className="text-gray-600 hover:text-[#1f2933]" data-id="element-3296">
                    Legal Guides
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Contact Form */}
          <div className="md:col-span-2" data-id="element-3297">
            <div className="bg-white border border-gray-300 p-8" data-id="element-3298">
              <h2 className="font-bold text-lg mb-6" data-id="element-3299">Send us a Message</h2>

              <form onSubmit={handleSubmit} className="space-y-4" data-id="element-3300">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3301">
                  <div data-id="element-3302">
                    <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-3303">
                      Name *
                    </label>
                    <input type="text" required value={formData.name} onChange={e => setFormData({
                    ...formData,
                    name: e.target.value
                  })} className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-3304" />
                  </div>

                  <div data-id="element-3305">
                    <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-3306">
                      Email *
                    </label>
                    <input type="email" required value={formData.email} onChange={e => setFormData({
                    ...formData,
                    email: e.target.value
                  })} className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-3307" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3308">
                  <div data-id="element-3309">
                    <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-3310">
                      Phone
                    </label>
                    <input type="tel" value={formData.phone} onChange={e => setFormData({
                    ...formData,
                    phone: e.target.value
                  })} className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-3311" />
                  </div>

                  <div data-id="element-3312">
                    <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-3313">
                      Subject *
                    </label>
                    <select required value={formData.subject} onChange={e => setFormData({
                    ...formData,
                    subject: e.target.value
                  })} className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-3314">
                      <option value="" data-id="element-3315">Select a subject</option>
                      <option value="general" data-id="element-3316">General Inquiry</option>
                      <option value="listing" data-id="element-3317">Listing Question</option>
                      <option value="technical" data-id="element-3318">Technical Support</option>
                      <option value="legal" data-id="element-3319">Legal Assistance</option>
                      <option value="partnership" data-id="element-3320">
                        Partnership Opportunity
                      </option>
                      <option value="other" data-id="element-3321">Other</option>
                    </select>
                  </div>
                </div>

                <div data-id="element-3322">
                  <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-3323">
                    Message *
                  </label>
                  <textarea required value={formData.message} onChange={e => setFormData({
                  ...formData,
                  message: e.target.value
                })} rows={6} className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-3324" />
                </div>

                <button type="submit" className="w-full py-3 bg-[#1f2933] text-white font-bold hover:bg-gray-800" data-id="element-3325">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-3326" />

      <MessageModal isOpen={isMessageModalOpen} onClose={() => setIsMessageModalOpen(false)} title="Message Sent" message="Thank you for contacting us! We'll respond within 24 hours." type="success" data-id="element-3327" />
    </div>;
}